import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Campaign from './pages/Campaign'
import CampaignPicker from './pages/CampaignPicker'
import Guide from './pages/Guide'

// In production the app is mounted at /campaign (see package.json "homepage").
// PUBLIC_URL is '' in dev, '/campaign' in the production build. Each campaign
// lives at its own URL (/campaign/:campaignId); the base path is a picker.
export default function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
      <Routes>
        <Route path="/" element={<CampaignPicker />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/guide/:slug" element={<Guide />} />
        <Route path="/:campaignId" element={<Campaign />} />
      </Routes>
    </BrowserRouter>
  )
}
